'use client';

import React from 'react';
import { OptionItemProps } from './interfaces';

/**
 * Single Responsibility: Render a single option item (checkbox or radio)
 * Open/Closed: Can be extended for different option types without modification
 */
export function OptionItem({
  option,
  isSelected,
  isDisabled = false,
  questionUid,
  questionIndex,
  optionIndex,
  label,
  inputType,
  correctness,
  showCorrectness = false,
}: OptionItemProps) {
  const inputId = `${questionUid}-${questionIndex}-${optionIndex}`;
  const inputName = questionUid;

  // Apply correct/wrong border (and fill when selected) for every option when showing results
  const getInputClassName = () => {
    let baseClass = `form-check-input ${inputType === 'checkbox' ? 'cursor-pointer' : ''} outline-focussed w-5 h-5`;
    if (showCorrectness && correctness !== null) {
      baseClass += correctness ? ' right-answer' : ' wrong-answer';
    }
    return baseClass;
  };

  const correctnessLabel =
    showCorrectness && correctness !== null
      ? correctness
        ? { text: 'Correct', className: 'text-green' }
        : { text: 'Incorrect', className: 'text-red' }
      : null;

  return (
    <div className="form-check flex items-center gap-2" role="group">
      <span className="relative flex-shrink-0">
        <input
          className={`${getInputClassName()} form-check-input-hover`}
          type={inputType}
          id={inputId}
          name={inputName}
          value={typeof option === 'boolean' ? option.toString() : option}
          checked={isSelected}
          disabled={isDisabled}
          autoComplete="off"
        />
      </span>
      <label
        className={`form-check-label cs-s-body-regular text-text-default-strong select-none m-0 flex-1 min-w-0 flex flex-col justify-center ${
          typeof option === 'boolean' ? 'text-capitalize' : ''
        } ${isDisabled ? 'cursor-default' : 'cursor-pointer'}`}
        htmlFor={inputId}
      >
        {label}
        {correctnessLabel && (
          <>
            <br />
            <span className={`cs-caption block ${correctnessLabel.className}`}>
              {correctnessLabel.text}
            </span>
          </>
        )}
      </label>
    </div>
  );
}

